import { render } from "./AddAgencyPage.vue?vue&type=template&id=2ac021c2&scoped=true"
import script from "./AddAgencyPage.vue?vue&type=script&lang=js"
export * from "./AddAgencyPage.vue?vue&type=script&lang=js"

import "./AddAgencyPage.vue?vue&type=style&index=0&id=2ac021c2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac021c2"]])

export default __exports__